module.exports = __webpack_public_path__ + "img/_14.7b189868.png";